import { render, staticRenderFns } from "./SegmentOfferTable.vue?vue&type=template&id=ab8fa1ec"
import script from "./SegmentOfferTable.vue?vue&type=script&lang=ts"
export * from "./SegmentOfferTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports